let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("jtHQR")).then(() => parcelRequire('cOAQ0'));